/** Match building, ghost rivals and shareable friend-challenges for Duelo. */
import { rngFrom, shuffle, pick } from '../lib/random.js'
import { questionsByCategory } from './questions.js'

export const MATCH_LENGTH = 7

const RIVAL_NAMES = [
  'Rival anónimo', 'La Sombra', 'Profesor X', 'Quijote', 'Teseo',
  'La Cóndor', 'Mercurio', 'Séneca', 'Boletín', 'Aleph',
]

export function buildMatch(seed, categoryId, grammar = 1) {
  const rng = rngFrom(seed)
  const pool = questionsByCategory(categoryId)
  const picked = shuffle(rng, pool).slice(0, MATCH_LENGTH)
  return picked.map((q) => {
    const order = shuffle(rng, q.a.map((_, i) => i))
    const options = order.map((i) => q.a[i])
    return {
      q: q.q,
      options,
      answerIndex: order.indexOf(q.r),
      cat: q.c,
      d: q.d,
      tries: grammar, // unused placeholder for future adaptive difficulty
    }
  })
}

export function makeRival(seed, playerElo) {
  const rng = rngFrom(seed ^ 0x9e3779b9)
  const name = pick(rng, RIVAL_NAMES)
  const jitter = Math.floor((rng() - 0.5) * 120)
  const elo = Math.max(700, Math.round(playerElo + jitter))
  return { name, elo }
}

/** Ghost rival accuracy scales with its Elo. */
export function simulateRival(seed, elo) {
  const rng = rngFrom(seed ^ 0x51ed270b)
  const p = Math.min(0.93, Math.max(0.3, 0.42 + (elo - 800) / 2600))
  let correct = 0
  for (let i = 0; i < MATCH_LENGTH; i++) if (rng() < p) correct++
  return correct
}

export function encodeChallenge({ seed, cat, name, score }) {
  const payload = { s: seed, c: cat, n: (name || 'Amigo').slice(0, 18), p: score }
  try {
    return 'CB1.' + btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
  } catch {
    return ''
  }
}

export function decodeChallenge(code) {
  try {
    const raw = String(code).trim().replace(/^CB1\./, '')
    const data = JSON.parse(decodeURIComponent(escape(atob(raw))))
    if (typeof data.s !== 'number' || !data.c) return null
    return { seed: data.s, cat: data.c, name: data.n || 'Amigo', score: data.p || 0 }
  } catch {
    return null
  }
}
